import { RequestService } from "../../../../common/services/RequestService";
import { GET_ORDER_PERSONS } from "./constants";

export const getOrderPersonsRequest = async (
  orderId,
  pagination,
  sort,
  personTypeKey
) => {
  let obj = {};
  if (sort && sort.order) {
    obj[`sort[${sort.columnKey}]`] =
      (sort.order === "ascend" && "asc") ||
      (sort.order === "descend" && "desc");
  }
  if (pagination) {
    obj["perPage"] = pagination.pageSize;
    obj["page"] = pagination.current;
  }
  obj["person_type_key"] = personTypeKey;

  let query = new URLSearchParams(obj);

  const response = await RequestService.get(
    GET_ORDER_PERSONS.replace("{order_id}", orderId) + "?" + query.toString()
  );
  return response;
};
